import React, { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import img from "../assets/img/Data.png"
interface CertificateProps {
  name: string;
  certificateNumber: string;
  imageUrl: string;
}

const CertificateGenerator: React.FC<CertificateProps> = ({ name, certificateNumber, imageUrl }) => {
  const certificateRef = useRef<HTMLDivElement>(null);

  const generatePDF = async () => {
    if (!certificateRef.current) return;

    const canvas = await html2canvas(certificateRef.current);
    const imgData = canvas.toDataURL(img);

    const pdf = new jsPDF('landscape', 'px', [canvas.width, canvas.height]);
    pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
    pdf.save(`${name}_Certificate.pdf`);
  };

  return (
    <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignContent:"center",alignItems:"center",padding:""}}>
      <div
        ref={certificateRef}
        style={{
          position: 'relative',
          width: '800px',
          height: '600px',
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '52%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '28px',
            fontWeight: 'bold',
            color: '#000',
          }}
        >
          {name}
        </div>
        <div
          style={{
            position: 'absolute',
            top: '10%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '20px',
            color: '#333',
          }}
        >
          Certificate No: {certificateNumber}
        </div>
      </div>

      <button onClick={generatePDF} style={{ marginTop: '20px' }}>
        Download PDF
      </button>
    </div>
  );
};

export default CertificateGenerator;